import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useOgTags } from "@/components/store/SeoJsonLd";

export default function Guides() {
  const [guides, setGuides] = useState(null);

  useEffect(() => {
    api.get("/guides").then((r) => setGuides(r.data)).catch(() => setGuides([]));
  }, []);

  useOgTags({
    title: "Jewellery Guides — Siyaara",
    description: "Plain-English guides on gold purity, hallmarking, diamond choices, sizing and care — written by Siyaara's bench and buying team.",
    url: "https://siyaara.com/guides",
  });

  useEffect(() => {
    document.title = "Jewellery Guides — Gold, Diamonds & Care | Siyaara";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
    meta.content = "Plain-English guides on gold purity, BIS hallmarking, lab-grown diamonds, ring sizing and jewellery care.";
  }, []);

  return (
    <div className="container-x py-10" data-testid="guides-page">
      <p className="eyebrow">LEARN</p>
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-1">Guides, written plainly</h1>
      <p className="text-stone-600 mt-2 max-w-2xl">Everything we wish someone had told us before our first jewellery purchase — purity, hallmarking, diamonds, sizing and care.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        {(guides || []).map((g) => (
          <Link key={g.slug} to={`/guides/${g.slug}`} className="border border-stone-200 bg-white p-5 hover:border-brand transition-colors group" data-testid={`guide-${g.slug}`}>
            <p className="font-heading text-lg font-medium group-hover:text-brand leading-snug">{g.title}</p>
            <p className="text-xs text-stone-500 mt-2 line-clamp-2">{g.meta_description}</p>
            <p className="text-[11px] font-mono text-stone-400 mt-3">{g.author}{g.published_at ? ` · ${new Date(g.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}` : ""}</p>
          </Link>
        ))}
      </div>
      {guides && guides.length === 0 && (
        <div className="border border-dashed border-stone-300 rounded-lg p-10 text-center text-stone-500 text-sm mt-8" data-testid="guides-empty">
          Our first guides are in editorial review — check back shortly.
        </div>
      )}
      <div className="mt-8 text-sm">
        <Link to="/guides/glossary" className="text-brand underline underline-offset-4" data-testid="glossary-link">Browse the jewellery glossary →</Link>
      </div>
    </div>
  );
}
